import { useCallback, useRef } from 'react';

import download from 'downloadjs';
import { useLogger } from 'ui-components/src/hooks/useLogger';
import { useFetch } from '../useFetch';

export const useFileDownload = (
  onError: (err: string) => void,
): UseFileDownloadValues => {
  const { fetch, loading } = useFetch();
  const logger = useLogger();
  const abortController = useRef(new window.AbortController()).current;
  const downloadFile: DownloadFn = useCallback(
    async (url: string, name: string, mimeType: string) => {
      try {
        const response = await fetch(url, {
          signal: abortController.signal,
        });
        const blob = await response.blob();

        download(blob, name, mimeType);
      } catch (error) {
        logger.error(error);
        onError(`The file ${name} could not be downloaded`);
      }
    },
    [abortController, logger, fetch, onError],
  );

  return {
    download: downloadFile,
    isDownloading: loading,
  };
};

export interface UseFileDownloadValues {
  download: DownloadFn;
  isDownloading: boolean;
}

type DownloadFn = (
  url: string,
  name: string,
  mimeType: string,
) => Promise<void>;
